<template>
    <div class="faqListSection frame">
        <h3>{{'pages/faq.title' | trans }}</h3>
        <div class="faqSidebarList">
            <a class="faqSidebarElement" :href="'/faq?show=' + faq.link"
                v-for="faq in recentFAQ"
                v-if="faq.hasOwnProperty('title')"
                v-bind:class="[(faq.link === activeElement && $route.meta.faqPage) ? 'isActive' : '']">
                <h4 class="title">{{faq.title}}</h4>
                <p class="block subtitle">{{faq.description}}</p>
            </a>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex';

    export default {
        data() {
            return {
                activeElement: '',
            }
        },
        computed: {
            ...mapState(['faqs']),
            recentFAQ: function () {
                return this.faqs;
            }
        },
        mounted() {
            this.activeElement = this.$route.query.show;
            if (typeof(this.faqs) == "undefined" || !this.faqs.length) {
                this.$store.dispatch('getFAQs');
            }
        },
    }
</script>